// extracted by mini-css-extract-plugin
export var postHeader = "post-header-module--postHeader--31a95";